import { useCallback } from 'react';

import {
  lookupScaleWeightFromQr,
  submitCameraQrReading,
  submitManualScaleWeight,
} from './kioskApi';
import { mergeReadings } from './kioskTransforms';

export function useKioskReadingActions({
  currentRequest,
  refreshCurrentRequest,
  setReadings,
  setReadingsState,
}) {
  const handleCameraQrDetected = useCallback(async (readingValue) => {
    if (!currentRequest?.requestId) {
      throw new Error('กรุณาเตรียมคำขอการชั่งก่อนสแกน QR');
    }

    const createdReading = await submitCameraQrReading(
      currentRequest.requestId,
      readingValue,
    );
    setReadings((current) => mergeReadings(current, createdReading));
    setReadingsState({ type: 'success', message: '' });
    refreshCurrentRequest();
    return createdReading;
  }, [currentRequest?.requestId, refreshCurrentRequest, setReadings, setReadingsState]);

  const handleQrWeightLookup = useCallback(async () => {
    if (!currentRequest?.requestId) {
      throw new Error('กรุณาเตรียมคำขอการชั่งก่อนค้นหาน้ำหนักจาก QR');
    }

    const createdReading = await lookupScaleWeightFromQr(currentRequest.requestId);
    setReadings((current) => mergeReadings(current, createdReading));
    setReadingsState({ type: 'success', message: '' });
    refreshCurrentRequest();
    return createdReading;
  }, [currentRequest?.requestId, refreshCurrentRequest, setReadings, setReadingsState]);

  const handleManualWeightSubmit = useCallback(async (weightKg) => {
    if (!currentRequest?.requestId) {
      throw new Error('กรุณาเตรียมคำขอการชั่งก่อนบันทึกน้ำหนัก');
    }

    const createdReading = await submitManualScaleWeight(currentRequest.requestId, weightKg);
    setReadings((current) => mergeReadings(current, createdReading));
    setReadingsState({ type: 'success', message: '' });
    refreshCurrentRequest();
    return createdReading;
  }, [currentRequest?.requestId, refreshCurrentRequest, setReadings, setReadingsState]);

  return {
    handleCameraQrDetected,
    handleManualWeightSubmit,
    handleQrWeightLookup,
  };
}
